module.exports = "https://static.energy5.com/_next/static/images/endToEnd-7ba87f322c5e4f39e06dc9bb21915082.png";